// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Logout_modalWrapper__kTXhm","roundIconWrapper":"Logout_roundIconWrapper__MYF4J"};